import { render } from "./SearchDialog.vue?vue&type=template&id=4b7c47e8&scoped=true"
import script from "./SearchDialog.vue?vue&type=script&lang=js"
export * from "./SearchDialog.vue?vue&type=script&lang=js"

import "./SearchDialog.vue?vue&type=style&index=0&id=4b7c47e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7c47e8"]])

export default __exports__